module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.locations) ? _c('div', [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-order": "asc",
      "md-card": "",
      "md-fixed-header": ""
    },
    on: {
      "md-selected": _vm.onSelect
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {
          attrs: {
            "md-selectable": "single"
          }
        }, [_c('md-table-cell', {
          attrs: {
            "md-label": "Name",
            "md-sort-by": "name"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Address",
            "md-sort-by": "address"
          }
        }, [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "Description",
            "md-sort-by": "description"
          }
        }, [_vm._v(_vm._s(item.description))])], 1)
      }
    }]),
    model: {
      value: (_vm.searched),
      callback: function($$v) {
        _vm.searched = $$v
      },
      expression: "searched"
    }
  }, [_c('md-table-toolbar', [_c('div', {
    staticClass: "md-toolbar-section-start"
  }, [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-fab md-mini md-primary",
    on: {
      "click": function($event) {
        _vm.showCreateLocationDialog = true
      }
    }
  }, [_c('md-icon', [_vm._v("add_location")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Create a new location")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.refetch()
      }
    }
  }, [_c('md-icon', [_vm._v("refresh")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Refetch location")])], 1)], 1), _vm._v(" "), _c('md-field', {
    staticClass: "md-toolbar-section-end",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('md-icon', [_vm._v("search")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "placeholder": "Search by name..."
    },
    on: {
      "input": _vm.searchOnTable
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('md-table-empty-state', {
    attrs: {
      "md-label": "No locations found",
      "md-description": _vm.emptyStateDescription
    }
  })], 1), _vm._v(" "), _c('UpsertLocationDialog', {
    attrs: {
      "show": _vm.showCreateLocationDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateLocationDialog = false
      }
    }
  })], 1) : _c('div', [_c('md-progress-spinner', {
    staticClass: "wait",
    attrs: {
      "md-diameter": 100,
      "md-stroke": 10,
      "md-mode": "indeterminate"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3de46011","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listingComponents/locations.vue
// module id = 445
// module chunks = 1